import styled from 'styled-components';
import fonts from 'constants/fonts';

export const UserCardWrapper = styled.div`
  background-color: #F1F1F1;
  height: 90vh;
  overflow: scroll;
  width: 100%;
  .loading {
    font-size: 1.6rem;
    text-align: center;
    padding: 2rem;
  }

  .header {
    display: flex;
    align-items: center;
    padding: 1rem;
    min-height: 15rem;

    .username {
      font-size: 1.6rem;
      font-weight: ${fonts.boldWeight};
      font-family: ${fonts.boldFamily};
      color: #000;
      margin-top: 1rem;
      margin-left: 1rem;
    }

    .overview {
      font-size: 1.4rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
      line-height: 1.9rem;
      overflow: auto;
      margin-left: 1rem;
      background: white;
      padding: 1.5rem;
      border-radius: 2rem;
      display: flex;
      flex-direction: column;
      .close {
        place-self: flex-end;
        color: #2680EB;
        cursor: pointer;
      }
    }
    .overview_empty {
      font-size: 1.4rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
      line-height: 1.9rem;
      margin-left: 1rem;
      background: white;
      padding: 1.5rem;
      border-radius: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      color: #2680EB;
      cursor: pointer;
    }
  }

  .tab_content {
    padding: 0rem;
    overflow: auto;

    .separator {
      display: flex;
      align-items: center;
      background-color: #D9D9D9;
      color: #5E5E5E;
      font-size: 1.6rem;
      font-weight:  ${fonts.regularWeight};
      font-family: ${fonts.regularFamily};
      background: attr(data-color);
      padding: 1rem 1rem 1rem 3rem;
      margin-top: 2rem;
      img {
        height: 2rem;
        margin-right: 0.5rem;
        color: 
      }
      &.answer{
        color: white;
      }
    }

    .title {
      color: #5E5E5E;
      font-size: 1.3rem;
      margin-bottom: 1rem;
      margin-top: 2rem;
    }
    
    .subsection {
      margin: 2rem 3rem;
    }

    .subsection_content{
      margin: 2rem 2rem;
    }
  
    .subsection_content::-webkit-scrollbar{
      display: none;
    }

    .container_tags {
      background-color: #E8E8E8;
      border-radius: 2rem;
      padding: 1rem 1rem 0;
      margin: 1rem;

      .description_tag {
        display: inline-block;
        vertical-align: middle;
        margin-right: 1rem;
        margin-bottom: 1rem;
        font-size: 1.4rem;
        color: #000;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/UserCard/components/styles.js